import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IInternalContactAgreement, internalContactAgreementsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { type IByInternalContactAgreementState } from './types';

const INTERNAL_CONTACT_AGREEMENT_MODULE = 'internalContactAgreement';

const state: IByInternalContactAgreementState = {
    byAgreement: new Map()
};

const dataObjectModule = getDataObjectsModule<IInternalContactAgreement>(internalContactAgreementsManager, 3);
const searchModule = getSearchModule<IInternalContactAgreement>(internalContactAgreementsManager);

const internalContactAgreementModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions, state, getters, mutations });
store.registerModule(INTERNAL_CONTACT_AGREEMENT_MODULE, internalContactAgreementModuleInstance);

export { INTERNAL_CONTACT_AGREEMENT_MODULE };
